import { h, render } from 'preact'
import App from './containers/App'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-recent-news')

if ( container ) {
  const language = container.dataset.language
  render( <App language={language} />, container )
}



// WEBPACK FOOTER //
// ./src/js/recent-news/index.js